<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <h4 class="font-weight-medium mb-1">{{ title }}</h4>
      <slot name="actions"></slot>
    </div>
    <v-card v-show="!hideCard">
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    hideCard: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>